import { useState, useEffect } from 'react';
import i18n from 'lang/i18n';

export default function LanguageReadyGate({ children }) {
  const [ready, setReady] = useState(i18n.isInitialized);

  useEffect(() => {
    if (!i18n.isInitialized) {
      i18n.on('initialized', () => setReady(true));
    } else {
      setReady(true);
    }

    return () => {
      i18n.off('initialized', () => setReady(true));
    };
  }, []);

  if (!ready) return null;
  return children;
}